type RouteParameter = {
  readonly prefix: string;
  readonly wildcard: boolean;
  readonly key: string;
  readonly suffix: string;
  readonly optional: boolean;
};

export function routeParameter(segment: string): RouteParameter | null {
  const match = /^(?:([^:*]*):|(\*))([^.?]+)(\.[^?]+)?(\?)?$/.exec(segment);
  const key = match?.[3];

  if (!match || key === undefined) return null;

  return {
    prefix: match[1] ?? "",
    wildcard: match[2] === "*",
    key,
    suffix: match[4] ?? "",
    optional: match[5] === "?",
  };
}
